import http from 'hub-http/clients/apiClient';
export const getEngagementData = engagementId => {
  return http.get(`engagements/v1/engagements/${engagementId}`);
};